module.exports = __webpack_public_path__ + "img/head.936b741a.png";